<template>
  <div :id="id" class="sd-sec">
    <span class="bar" />
    <h2>{{ title }}</h2>
    <span v-if="note" class="note">{{ note }}</span>
    <span class="grow" />
    <slot />
  </div>
</template>
<script>
export default { name: 'SdSectionTitle', props: { title: String, note: String, id: String } }
</script>
